import React from "react";
import { useTranslation } from "react-i18next";

import { projectPortfolio } from "@planzone/dto";
import {
  useCreateProjectPortfolio,
  useRetrieveCurrentPlanzone,
  useZonesProjectsRetrieval,
} from "@planzone/view-models";
import { Button } from "@common/button";
import { Modal } from "@common/modal";
import { Form } from "./form";
import { Props } from "./types";
import styles from "./styles.scss";

function ProjectPortfolioCreation(props: Props) {
  const { t } = useTranslation();
  const [formData, setFormData] = React.useState(projectPortfolio);
  const { planzone } = useRetrieveCurrentPlanzone();
  const {
    projects,
    isRequestPending: isProjectsRequestPending,
    isRequestSuccess: isProjectsRequestSuccess,
    isRequestFailure: isProjectsRequestFailure,
    retrieveZonesProjects,
  } = useZonesProjectsRetrieval();
  const { isRequestPending, error, createProjectPortfolio } =
    useCreateProjectPortfolio();

  React.useEffect(() => {
    !isProjectsRequestPending &&
      !isProjectsRequestSuccess &&
      !isProjectsRequestFailure &&
      retrieveZonesProjects(planzone);
  }, []);

  return (
    <Modal
      header={t("projectPortfolioCreation.title")}
      className={styles.projectPortfolioCreation}
      close={props.cancel}
    >
      <form
        className={styles.form}
        onSubmit={(event) => {
          event.preventDefault();
          !isRequestPending &&
            createProjectPortfolio({ planzone, portfolio: formData });
        }}
      >
        <div className={styles.main}>
          <div className={styles.form}>
            <Form
              projects={projects}
              formData={formData}
              error={error}
              editForm={setFormData}
            />
          </div>
        </div>
        <div className={styles.buttons}>
          <Button type="cancel" press={props.cancel}>
            {t("projectPortfolioCreation.cancel")}
          </Button>
          <Button type="submit" status={isRequestPending ? "pending" : "none"}>
            {t("projectPortfolioCreation.submit")}
          </Button>
        </div>
      </form>
    </Modal>
  );
}

export { ProjectPortfolioCreation };
